export default __webpack_public_path__ + "static-bigflip/media/icon-uploadcsv.1b1100e3.png";